import { CodebookModel } from 'app/shared/model/shared.model';

export interface Intervention {
  idIntervention: number;
  uuid: string;
  constructionBuildingProcedure: CodebookModel[];
  additionalDescription: CodebookModel[];
  buildingPurpose: CodebookModel[];
  buildingPurposeAdditionalDescription: string;
  requirementGroup: CodebookModel[];
  geometryExists: boolean;
  constructionCommencement: CodebookModel[];
  buildingTypeNationalClassification: CodebookModel[];
  greenInfrastructureType: CodebookModel[];
  greenInfrastructureArea: number;
  ordering: number;
}

export interface InterventionView {
  idIntervention: number;
  idCase: number;
  idConstructionBuildingProcedure: number;
  idBuildingPurpose: number;
  cbpBuildingPurpose: string;
  buildingPurposeAdditionalDescription: string;
  idRequirementGroup: number;
  requirementGroup: string;
  ordering: number;
}

export const initialIntervention = {
  uuid: '',
  constructionBuildingProcedure: [],
  additionalDescription: [],
  buildingPurpose: [],
  buildingPurposeAdditionalDescription: '',
  requirementGroup: [],
  geometryExists: false,
  constructionCommencement: [],
  buildingTypeNationalClassification: [],
  greenInfrastructureType: [],
  greenInfrastructureArea: '',
  ordering: 0,
};
